import './CaseResolutionCase.scss';

import {
    AssertionDescriptorUsageTypesEnum,
    AssertionDescriptorValueSourceTypeEnum,
    CaseResolutionStepsEnum,
    EntityTypes,
} from '../../../../utilities/Constants';
import { Bounce, toast } from 'react-toastify';
import { ICaseAssertionModel, ICaseModel, IDocumentModel } from '../../../../interfaces/ICase';
import { useEffect, useState } from 'react';

import Auth from '../../../../stores/authentication';
import Authorization from '../../../../stores/Authorization';
import { CaseFileSection } from '../../../../components/case/CaseFileSection';
import { CaseResolutionAdvanceModal } from '../components/CaseResolutionAdvanceModal';
import { CaseResolutionHeader } from '../components/CaseResolutionHeader';
import { CaseResolutionSettings } from '../components/CaseResolutionSettings';
import { CaseResolutionStepper } from '../components/CaseResolutionStepper';
import { CaseResolutionSubmitModal } from '../components/CaseResolutionSubmitModal';
import CheckmateApiClient from '../../../../services/apiClient';
import { DocumentTitle } from '../../../../components/shared/DocumentTitle';
import { DocumentsList } from '../../../../components/documents-list/DocumentsList';
import { IAssertionDescriptorModel } from '../../../../interfaces/IAssertionDescriptor';
import { ICaseResolutionModel } from '../../../../interfaces/ICaseResolutionModel';
import { IOrganizationSettingModel } from '../../../../interfaces/IOrganization';
import { IValidation } from '../../../../interfaces/IError';
import { Loader } from '../../../../components/shared/Loader';
import { LoadingButton } from '../../../../shared/buttons/LoadingButton';
import { LocalRoutes } from '../../../../utilities/LocalRoutes';
import { MainContentOverlayComponent } from '../../../../components/shared/MainContentOverlay';
import { PDReview } from './PDReview';
import { PageWithAffixedHeader } from '../../../../shared/PageWithAffixedHeader';
import Sort from '../../../../stores/Sort';
import { Stack } from 'react-bootstrap';
import ValidateUtils from '../../../../shared/validations';
import { WorkLog } from '../components/WorkLog';
import _ from 'lodash';
import { useAuthContext } from '../../../../contexts/AuthContext';
import { useCaseFileContext } from '../../../../contexts/useCaseFileContext';
import { useGetCaseResolutionUpdate } from '../../case-resolution-admin/useGetCaseResolutionUpdate';
import { useParams } from 'react-router-dom';
import { useZoneContext } from '../../../../contexts/useZoneContext';
import { useZoneUsers } from '../../../../shared/react-query-hooks/useZoneUsers';

const _apiClient = new CheckmateApiClient();

const steps = [<></>, <></>, <></>, <></>, <></>, PDReview];

export function CaseResolutionCase() {
    const { guid } = useParams<{ guid: string }>();
    const { resolutionguid } = useParams<{ resolutionguid: string }>();
    const { user, isLoggedIn, isLoadingUser } = useAuthContext();

    const zoneContext = useZoneContext();
    const zoneUsersApi = useZoneUsers(zoneContext.zoneApiClient);

    const { displaySections, currentCase, setCurrentCase } = useCaseFileContext();
    const zoneUsers = zoneUsersApi.data ?? [];

    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [validation, setValidation] = useState<IValidation>({});
    const [, setOrganizationSettings] = useState<IOrganizationSettingModel[]>([]);
    const [showSettingsDialog, setShowSettingsDialog] = useState<boolean>(false);
    const [showWorkLog, setShowWorkLog] = useState<boolean>(false);
    const [trafficLightRating, setTraficLightRating] = useState<number>(0);
    const [showAdvanceModal, setShowAdvanceModal] = useState<boolean>(false);
    const [showSubmitModal, setShowSubmitModal] = useState<boolean>(false);
    const [rejectCaseStep, setRejectCaseStep] = useState<boolean>(false);
    const [isRejecting, setIsRejecting] = useState<boolean>(false);
    const [isSaving, setIsSaving] = useState<boolean>(false);
    const [currentCaseResolutionCase, setCurrentCaseResolutionCase] =
        useState<ICaseResolutionModel>();
    const [documents, setDocuments] = useState<IDocumentModel[]>([]);
    const [stepKey, setStepKey] = useState<number>(0);

    const isSystemAdmin = user ? Auth.isSystemAdmin(user) : false;
    const saveCaseResolutionCaseMutation = useGetCaseResolutionUpdate();
    const caseCurrentStep = currentCaseResolutionCase?.steps.find((x) => x.isActive);

    const fetchCaseDetailsById = async (id: string) => {
        const response = await zoneContext.zoneApiClient.getCaseById(id);
        if (response.httpResponse.status == 401) {
            window.location.reload();
            return;
        }
        if (response.errorMessage) {
            return;
        }
        return response.payload;
    };

    const fetchCaseAssertionsForNewCase = async () => {
        const response = await zoneContext.zoneApiClient.getAssertionDescriptors(
            AssertionDescriptorUsageTypesEnum.Case
        );
        if (response.httpResponse.status == 401) {
            window.location.reload();
            return;
        }
        if (response.errorMessage) {
            return;
        }
        const caseAssertions: ICaseAssertionModel[] = [];
        response
            .payload!.filter(
                (x) => x.valueSourceType!.id != AssertionDescriptorValueSourceTypeEnum.Implied.Value
            )
            .map((assertionDescriptor: IAssertionDescriptorModel) => {
                const caseAssertion: ICaseAssertionModel = {
                    assertionDescriptorGuid: assertionDescriptor.guid,
                };
                caseAssertions.push(caseAssertion);
            });
        return caseAssertions;
    };
    const fetchLoggedInUserDefaultOrganization = async () => {
        const response = await zoneContext.zoneApiClient.getCurrentUserOrganizationFromServer(
            zoneContext.zoneGuid
        );
        if (!response) return;
        if (response.httpResponse.status == 401) {
            window.location.reload();
            return;
        }
        if (response.errorMessage) {
            return;
        }
        return response.payload;
    };

    //Fetch methods
    const fetchCaseFileModel = async () => {
        const response = await zoneContext.zoneApiClient.getCaseFileModel();
        if (response.httpResponse.status == 401) {
            window.location.reload();
            return;
        }
        if (response.errorMessage) {
            return;
        }

        return response.payload;
    };
    // const fetchCaseFileStaticItems = async () => {
    //     const response = await zoneContext.zoneApiClient.getCaseFileStaticItems();
    //     if (response.httpResponse.status == 401) {
    //         window.location.reload();
    //         return;
    //     }
    //     if (response.errorMessage) {
    //         return;
    //     }
    //     return response.payload;
    // };
    // const fetchAssertionDescriptors = async () => {
    //     const response = await zoneContext.zoneApiClient.getAssertionDescriptors(
    //         AssertionDescriptorUsageTypesEnum.Case
    //     );
    //     if (response.httpResponse.status == 401) {
    //         window.location.reload();
    //         return;
    //     }
    //     if (response.errorMessage) {
    //         return;
    //     }
    //     return response.payload;
    // };
    // const fetchCaseStatusLookup = async () => {
    //     const response = await _apiClient.getCaseStatusLookupData();
    //     if (response.httpResponse.status == 401) {
    //         window.location.reload();
    //         return;
    //     }
    //     if (response.errorMessage) {
    //         throw new Error(response.errorMessage);
    //     }
    //     return response.payload;
    // };
    // const fetchAllUsersInZone = async () => {
    //     const response = await zoneContext.zoneApiClient.getUsersInZone();
    //     if (response.httpResponse.status == 401) {
    //         window.location.reload();
    //         return;
    //     }
    //     if (response.errorMessage) {
    //         throw new Error(response.errorMessage);
    //     }
    //     return response.payload;
    // };
    const fetchCaseFileDisplayCategories = async () => {
        const response = await _apiClient.getCaseFileDisplayCategories();
        if (response.httpResponse.status == 401) {
            window.location.reload();
            return;
        }
        if (response.errorMessage) {
            return;
        }
        return response.payload;
    };
    const fetchOrganizationSettings = async () => {
        const response = await zoneContext.zoneApiClient.getOrganizationSettings();
        if (response.httpResponse.status == 401) {
            window.location.reload();
            return;
        }
        if (response.errorMessage) {
            throw new Error(response.errorMessage);
        }

        return response.payload;
    };
    const fetchCurrentCaseResolution = async (caseId: string) => {
        const response = await _apiClient.getCaseResolutionCase(caseId);
        if (response.httpResponse.status == 401) {
            window.location.reload();
            return;
        }
        if (response.errorMessage) {
            throw new Error(response.errorMessage);
        }

        return response.payload;
    };
    const fetchCaseResolutionDraft = async (caseId: string) => {
        const response = await zoneContext.zoneApiClient.getCaseResolutionDraft(caseId);
        if (response.httpResponse.status === 204) return;

        if (response.httpResponse.status == 401) {
            window.location.reload();
            return;
        }
        if (response.errorMessage) {
            throw new Error(response.errorMessage);
        }
        return response.payload;
    };
    const fetchStepHistoryAll = async (caseId: string) => {
        const response = await _apiClient.getCaseResolutionStepHistoryAll(caseId);
    

        if (response.httpResponse.status == 401) {
            window.location.reload();
            return;
        }
        if (response.errorMessage) {
            throw new Error(response.errorMessage);
        }


        return response.payload.data; 
    }

    useEffect(() => {
        if (!isLoadingUser && isLoggedIn && zoneContext.zoneGuid !== '') {
            if (
                !Authorization.isAuthorizedToRoute(LocalRoutes.CaseFile, user, zoneContext.zoneGuid)
            ) {
                zoneContext.zoneNavigate(LocalRoutes.AccessDenied);
            }
            loadInitialData(guid);
        }
    }, []);

    const loadInitialData = async (caseGuid?: string) => {
        if (!user.active) return;

        let currentCase: ICaseModel = {};
        let enableCaseFileEdit = false;
        let enablePlanningExecution = false;

        if (caseGuid) {
            // Edit existing case
            const caseAPIResponse = await fetchCaseDetailsById(caseGuid);
            if (!caseAPIResponse) {
                const validation: IValidation = {};
                validation.model = ['Case not found!'];
                setValidation(validation);
                return;
            }

            currentCase = caseAPIResponse;

            if (currentCase.organization) {
                if (currentCase.organization.enableCaseFileEdit) enableCaseFileEdit = true;
                if (currentCase.organization.enablePlanningExecution)
                    enablePlanningExecution = true;
            }
        }

        // Custom Logic if Logged In User is an Employee of the Portfolio or Company organization. Always disable case File Edit and PlanningExecution
        const caseBelongsToUserOrg =
            (user.homeOrganization &&
                currentCase.organization!.primaryAssociatedOrganization?.guid ===
                    user.homeOrganization?.guid) ||
            user.homeOrganization!.guid == currentCase.organization!.guid;

        if (isSystemAdmin || caseBelongsToUserOrg) {
            enableCaseFileEdit = false;
            enablePlanningExecution = false;
        }

        setIsLoading(true);
        let hasErrors = false;
        await Promise.all([
            fetchCaseResolutionDraft(resolutionguid!),
            fetchCurrentCaseResolution(resolutionguid!),
        ])
            .then(([caseResolutionDocuments, caseResolution]) => {
                const orderedDocs = (caseResolutionDocuments ?? []).sort(
                    Sort.compareDate('modifiedDate', undefined, 'desc')
                );
                setDocuments(orderedDocs);
                setCurrentCaseResolutionCase(caseResolution ?? undefined);

                handleGoToCurrentStep(caseResolution!);
            })
            .catch((error: Error) => {
                hasErrors = true;
                setValidation(ValidateUtils.parseErrors([], error.message));
            })
            .finally(() => {
                setIsLoading(false);
            });

        if (hasErrors) return;

        setCurrentCase(currentCase);
        setIsLoading(true);

        await fetchOrganizationSettings()
            .then((orgSettings) => setOrganizationSettings(orgSettings ?? []))
            .catch((error: Error) => setValidation(ValidateUtils.parseErrors([], error.message)))
            .finally(() => {
                setIsLoading(false);
            });
    };

    const handleGoToCurrentStep = (caseResolution: ICaseResolutionModel | undefined) => {
        if (!caseResolution) return;

        const activeStepIndex = caseResolution.steps.findIndex((step) => step.isActive);
        setStepKey(activeStepIndex + 1);
    };

    const handleGoToStepClick = () => setShowAdvanceModal(true);

    const getUser = (userId: string | undefined) => {
        if (!userId) return;
        const user = zoneUsers.find((x) => x.guid === userId);
        if (user) {
            return user.profile?.firstName + ' ' + user.profile?.lastName;
        }
        return undefined;
    };

    const handleRejectDraftClick = () => {
        setRejectCaseStep(true);
        setShowAdvanceModal(true);
    };

    const handleRejectStep = async () => {
        setRejectCaseStep(false);
        setShowAdvanceModal(false);
        setIsRejecting(true);
        if (!currentCaseResolutionCase) return;

        if (currentCaseResolutionCase && caseCurrentStep) {
            const response = await _apiClient.rejectCaseResolutionStep(
                currentCaseResolutionCase.id,
                caseCurrentStep.id
            );

            if (response.httpResponse.status == 401) {
                window.location.reload();
                return;
            }
            setIsRejecting(false);

            setStepKey((prev) => prev - 1);
        }
        // loadInitialData(guid);
    };

    const handleSaveSettings = (caseResolutionCase: ICaseResolutionModel) => {
        saveCaseResolutionCaseMutation
            .mutateAsync(caseResolutionCase)
            .then((result) => {
                setCurrentCaseResolutionCase(result);

                toast.success(
                    <span>
                        Case Resolution for{' '}
                        <span className="bold">{currentCaseResolutionCase?.caseName}</span> updated!
                    </span>,
                    {
                        position: 'bottom-center',
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                        progress: undefined,
                        theme: 'light',
                        transition: Bounce,
                    }
                );
            })
            .catch((error) =>
                toast.error(
                    <span>
                        Saving the Case Resolution for{' '}
                        <span className="bold">{currentCaseResolutionCase?.caseName}</span> failed!
                        <p>{error.errorMessage}</p>
                    </span>,
                    {
                        position: 'bottom-center',
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                        progress: undefined,
                        theme: 'light',
                        transition: Bounce,
                    }
                )
            );
    };

    const handleGoToNextStep = async () => {
        if (currentCaseResolutionCase && caseCurrentStep) {
            if (caseCurrentStep.stepData.ratings.length <= 0) {
                caseCurrentStep.stepData.ratings = {
                    starRating: 0,
                };
            }

            caseCurrentStep.stepData.ratings = {
                starRating: trafficLightRating,
            };
            if (!caseCurrentStep.stepData.notes) {
                caseCurrentStep.stepData.notes = '';
            }

            setIsSaving(true);
            await _apiClient.approveCaseResolutionStep(
                currentCaseResolutionCase.id,
                caseCurrentStep.id,
                caseCurrentStep.stepData
            );
            setTraficLightRating(0);
            setShowAdvanceModal(false);
            setIsSaving(false);

            if (stepKey < steps.length) {
                setStepKey(stepKey + 1);
            }
        }
        return;
    };

    const handleRatingClick = (star: number) => {
        if (star === trafficLightRating) {
            setTraficLightRating(0);
        }
        setTraficLightRating(star);
    };

    const getTrafficColor = (star: number) => {
        if (star > trafficLightRating) {
            return '#e4e5e9';
        }
        if (trafficLightRating === 1) {
            return '#ff0000';
        }
        if (trafficLightRating === 2) {
            return '#f7b730';
        }
        return '#4abdac';
    };

    useEffect(() => {
        if (currentCaseResolutionCase && currentCase) {
            const a1User = currentCase.caseManagerUser?.guid ?? '';
            const a2User = currentCase.alternateCaseManagerUser?.guid ?? '';

            currentCaseResolutionCase.steps[1].userId = a1User;
            currentCaseResolutionCase.steps[2].userId = a2User;
        }
    }, [currentCase]);

    useEffect(() => {
        handleGoToCurrentStep(currentCaseResolutionCase);
        if (currentCaseResolutionCase?.completedDate) {
            setStepKey(6);
        }
    }, [currentCase]);

    const handleSubmitDraft = () => {
        setShowSubmitModal(false);
        handleGoToNextStep();
    };

    const handleCancel = () => {
        setShowSettingsDialog(false);
    };

    const handleSaveDocumentsComplete = (updatedDocuments: IDocumentModel[]) => {
        const documentsCopy = [...(documents ?? [])];

        for (const newDoc of updatedDocuments) {
            const foundIdx = documentsCopy.findIndex((doc) => doc.guid === newDoc.guid);
            if (foundIdx > -1) {
                documentsCopy[foundIdx] = newDoc;
            } else {
                documentsCopy.push(newDoc);
            }
        }
        documentsCopy.sort(Sort.compareDate('modifiedDate', undefined, 'desc'));
        setDocuments(documentsCopy);
    };

    const handleDeleteDocument = (documentGuid: string) =>
        setDocuments((prev) => prev.filter((d) => d.guid !== documentGuid));

    const stepHeader = Object.values(CaseResolutionStepsEnum).find((x) => x.Value === stepKey);

    const headerSection = displaySections[0] ?? [];

    if (isLoading) {
        return <Loader />;
    }

    return (
        <>
            <DocumentTitle title={'Case Resolution'} />
            {showSettingsDialog && (
                <MainContentOverlayComponent>
                    <>
                        <CaseResolutionSettings
                            onSettingsSave={handleSaveSettings}
                            onCancel={handleCancel}
                            user={user}
                            usersInZone={zoneUsers}
                            caseResolutionCase={currentCaseResolutionCase!}
                        />
                    </>
                </MainContentOverlayComponent>
            )}
            <PageWithAffixedHeader
                headerComponent={
                    <>
                        <CaseResolutionHeader
                            onSettingsClick={() => setShowSettingsDialog(true)}
                            handleLogClick={() => setShowWorkLog(true)}
                            user={user}
                        />
                        <hr />
                        <div style={{ padding: '10px 24px' }} className="container-fluid">
                            <CaseFileSection
                                isOpen
                                numberOfColumns={3}
                                section={headerSection}
                                user={user}
                                validation={validation}
                                displayAsCondensed={true}
                            />
                        </div>
                        <hr />
                        <CaseResolutionStepper
                            steps={currentCaseResolutionCase?.steps!}
                            currentStep={caseCurrentStep!}
                            stepKey={stepKey - 1}
                            zoneUsers={zoneUsers}
                        />
                        <hr style={{ marginBottom: 0 }} />
                    </>
                }
            >
                <div className="container-fluid" style={{ paddingBottom: 70 }}>
                    <div className="row">
                        <div className="col-5">
                            <div className="pt-3">
                                {currentCaseResolutionCase?.completedDate === null ? (
                                    <div>
                                        <div className="fw-bold mb-1 font-size-1_2">
                                            {stepHeader?.Title}
                                        </div>
                                        <div className="mb-0">
                                            {caseCurrentStep?.userId
                                                ? 'Assigned: ' +
                                                  getUser(
                                                      currentCaseResolutionCase!.steps[stepKey - 1]
                                                          .userId
                                                  )
                                                : stepHeader?.Unassigned}
                                        </div>
                                    </div>
                                ) : (
                                    <div style={{ width: '100%' }}>
                                        <h3 className="fw-bold mb-1 text-center">
                                            Case Resolution Complete
                                        </h3>
                                    </div>
                                )}
                                <div className="mt-4">
                                    <Stack direction="vertical" gap={3}>
                                        {stepKey > 3 &&
                                            !currentCaseResolutionCase?.completedDate && (
                                                <div style={{ height: '75px' }}>
                                                    <div className="bold">Rating</div>
                                                    <Stack direction="horizontal" gap={2}>
                                                        {[1, 2, 3].map((star) => (
                                                            <button
                                                                className="btn"
                                                                style={{
                                                                    border: 'none',
                                                                    padding: 0,
                                                                    fontSize: '2rem',
                                                                }}
                                                                key={star}
                                                                onClick={() =>
                                                                    handleRatingClick(star)
                                                                }
                                                                value={trafficLightRating}
                                                            >
                                                                <i
                                                                    className={'fa-solid fa-circle'}
                                                                    style={{
                                                                        color: getTrafficColor(
                                                                            star
                                                                        ),
                                                                    }}
                                                                />
                                                            </button>
                                                        ))}
                                                    </Stack>
                                                </div>
                                            )}
                                        {stepKey === 6 && (
                                            <div>
                                                <hr className="m-0 mb-3" />
                                                <div
                                                    className="bold text-gray mb-2"
                                                    style={{ fontSize: '1.25em' }}
                                                >
                                                    Other Ratings
                                                </div>
                                                <PDReview
                                                    caseResolutionCase={currentCaseResolutionCase!}
                                                />
                                            </div>
                                        )}
                                    </Stack>
                                </div>
                            </div>
                        </div>
                    </div>

                    {currentCaseResolutionCase?.id && (
                        <div className="pt-4">
                            <DocumentsList
                                authorizedToEdit
                                documentTypeId={6}
                                entityGuid={currentCaseResolutionCase?.id}
                                entityTypeId={EntityTypes.CaseResolutionPlan}
                                user={user}
                                documents={documents}
                                title={
                                    <h4 className="card-title" style={{ paddingLeft: '10px' }}>
                                        Attachments
                                    </h4>
                                }
                                onSaveComplete={handleSaveDocumentsComplete}
                                onDeleteComplete={handleDeleteDocument}
                            />
                        </div>
                    )}

                    <CaseResolutionActions
                        isCompleted={!!currentCaseResolutionCase?.completedDate}
                        isRejecting={isRejecting}
                        onGoToClick={handleGoToStepClick}
                        onRejectDraftClick={handleRejectDraftClick}
                        onSubmitClick={handleSubmitDraft}
                        stepKey={stepKey}
                        stepName={
                            stepKey === 0
                                ? (caseCurrentStep?.name ?? '')
                                : (currentCaseResolutionCase?.steps[stepKey]?.name ?? '')
                        }
                    />
                </div>
            </PageWithAffixedHeader>

            {showWorkLog && (
                <WorkLog
                    caseResolutionCase={currentCaseResolutionCase!}
                    caseHistory={[]} // todo jec
                    users={zoneUsers}
                    onHide={() => setShowWorkLog(false)}
                    open={showWorkLog}
                />
            )}
            {showAdvanceModal && (
                <CaseResolutionAdvanceModal
                    caseResolutionStep={caseCurrentStep!}
                    isReject={rejectCaseStep}
                    isSaving={isSaving}
                    onHide={() => setShowAdvanceModal(false)}
                    onContinue={handleGoToNextStep}
                    onReject={handleRejectStep}
                    open={showAdvanceModal}
                />
            )}
            {showSubmitModal && (
                <CaseResolutionSubmitModal
                    caseResolutionStep={caseCurrentStep!}
                    onHide={() => setShowSubmitModal(false)}
                    onContinue={handleSubmitDraft}
                    open={showSubmitModal}
                />
            )}
        </>
    );
}

interface ICaseResolutionActionsProps {
    isCompleted: boolean;
    isRejecting: boolean;
    onGoToClick: () => void;
    onRejectDraftClick: () => void;
    onSubmitClick: () => void;
    stepKey: number;
    stepName: string;
}

function CaseResolutionActions(props: ICaseResolutionActionsProps) {
    const { isCompleted, onGoToClick, onRejectDraftClick, onSubmitClick, stepKey, stepName } =
        props;

    return (
        <div
            style={{
                background: '#fff',
                borderTop: '1px solid #efefef',
                padding: '10px 15px',
                position: 'absolute',
                bottom: 0,
                left: 0,
                width: '100%',
            }}
        >
            <Stack direction="horizontal" style={{ justifyContent: 'end' }} gap={1}>
                {stepKey !== 1 && !isCompleted && (
                    <LoadingButton
                        icon="fal fa-cancel"
                        buttonCssClass="btn btn-default"
                        onClick={onRejectDraftClick}
                        text="Reject Draft"
                    />
                )}
                {stepKey !== 6 && !isCompleted && (
                    <button className="btn btn-orange" onClick={onGoToClick}>
                        Go to {stepName}
                    </button>
                )}
                {stepKey === 6 && !isCompleted && (
                    <button className="btn btn-orange" onClick={onSubmitClick}>
                        Submit Draft
                    </button>
                )}
            </Stack>
        </div>
    );
}
